module.exports = __webpack_public_path__ + "img/84000.b113c120.jpg";